// 按页面划分
export default {
    // 公共页面
    "common": {
        "title": "Trgovački centar",
        "pull_refresh": "Povucite se da biste se osvježili",
        "release_refresh": "Izdanje za osvježavanje",
        "refresh_loading": "Učitavanje…",
        "footer_text": "Usluge pruža Ucloudlink (NASDAQ: UCL)"
      },
      "home": {
        "input_placeholder": "Pretraživanje zemlje/regije",
        "my_flow": "Moji podaci",
        "charge_code": "Vaučerski kôd",
        "coupons": "Kuponi",
        "local_package": "Lokalni podaci",
        "more": "Više",
        "popular_destination": "Zemlja/regija",
        "buy_now": "Kupiti sada",
        "package_useing": "Aktivno",
        "unused": "Neaktivno",
        "download_app": "Preuzmite APP",
        "enter_the_mall_list": "Unesite popis trgovačkog centra",
        "no_data": "Nema podataka",
        "no_data_available": "Nema dostupnih podataka",
        "copy_success": "Kopirano uspješno",
        "copy_fail": "Kopiranje nije uspjelo",
        "meritsTitle": "Koje su prednosti?",
        "merits1": "Bez SIM kartice & Bez mjesečnih troškova",
        "merits2": "Integrirano s vrhovnim 2-3 operaterima za automatsko prebacivanje mreže",
        "go_buy": "Kupi sada",
        "instant_savings": "Uštedi",
        "expires_in": "Istječe za",
        "download_app_tips": "Preuzmite aplikaciju za više ponuda i iskustava"
      },
      "packages": {
        "sub_title": {
          "us": "Isključujući guam, saipan",
          "it": "Uključujući Vatikan, San Marino",
          "va": "Uključujući Italiju, San Marino",
          "sm": "Uključujući Italiju, Vatikanski grad",
          "ma": "Uključujući zapadnu Saharu",
          "eh": "Uključujući Maroko",
          "ch": "Uključujući Lihtenstein",
          "li": "Uključujući Švicarsku",
          "fr": "Uključujući Monako",
          "mc": "Uključujući Francusku",
          "fi": "Uključujući otoke Alanda",
          "ax": "Uključujući Finsku",
          "gu": "Uključujući i otoke sjeverne Mariane",
          "mp": "Uključujući Guam"
        },
        "unlimited_packages": "Neograničeni paket podataka",
        "normal_packages": "Normalni paket podataka",
        "multi_region_packages": "Multiregion",
        "regional_data": "Regionalni podaci",
        "high_speed_text": "Podaci velike brzine",
        "infiniteFlow": "Neograničeni podaci",
        "unLimitData": "Neograničen",
        "high_speed_text_year": "Velika brzina/MP",
        "package_list": "Popis paketa",
        "special_offer": "Popusti",
        "first_month": "1. Mjesec",
        "periodUnit": {
          "day": "Dan (i)",
          "month": "mjesec",
          "hour": "sat (s)",
          "year": "godina"
        },
        "periodUnits": {
          "day": "Dan (i)",
          "month": "mjeseci",
          "hour": "sat (s)",
          "year": "godina"
        },
        "periodUnitSimp": {
          "day": "d",
          "month": "za",
          "hour": "h",
          "year": "yr"
        },
        "periodUnitMonthly":"Mješečni",
        "periodUnitsSimp": {
          "day": "d",
          "month": "za",
          "hour": "h",
          "year": "yr"
        },
        "unlimited_good_name": {
          "day": "Dnevna propusnica",
          "month": "Mjesečni pokaz",
          "year": "Godišnji prolaz"
        },
        "continuousMonth": "Kontinuirani mjeseci",
        "continuousDay": "Nuolatinės dienos",
        "continuousYear": "Kontinuirane godine",
        "day_invalid": "Istječe na trenutni dan",
        "month_invalid": "Istek u tekućem mjesecu",
        "immediate_valid": "Odmah na snazi",
        "tomorrow_day_valid": "Na snazi od sljedećeg dana",
        "tomorrow_month_valid": "Na snazi od sljedećeg mjeseca",
        "detail": {
          "cell_flow": "Podaci",
          "cell_period": "Opravdanost",
          "buy_quantity": "Iznositi",
          "use_area": "Pokrivenost",
          "use_intro": "Uvjeti i odredbe",
          "buy_btn": "Redoslijed",
          "pay": "platiti",
          "buy_tips": "Imate paket %@packageName u uporabi. Želite li kupiti ovaj paket?",
          "haveOrderTips": "Stvorena narudžba s čekanjem plaćanja. Kliknite Potvrdi za pristup mojoj stranici podataka！"
        },
        "confirm": {
          "title": "Potvrda narudžbe",
          "real_pay_amount": "Iznos plaćen",
          "online_payment": "Online plaćanje",
          "create_order_error": "Postavljanje nije uspjelo"
        }
      },
      "pay": {
        "result": {
          "loading_order_status": "Dobivanje statusa narudžbe…",
          "buy_success": "Naručite dovršeno",
          "buy_pending": "Potvrda čekanja",
          "buy_pending_tip": "Plaćanje u postupku ... Ako plaćanje nije premješteno u roku od 10 minuta, obratite nam se za podršku.",
          "get_payment_info_fail": "Informacije o plaćanju Akvizicija nije uspjela",
          "cell_package": "Paket",
          "cell_buy_amount": "Subtotalan",
          "cell_real_amount": "Iznos plaćen",
          "go_to_order_btn": "Idi na moj paket",
          "back_home": "Povratak kući",
          "back_mall": "Povratak u trgovački centar",
          "ordersn_empty": "Narudžba sn ne može biti prazna",
          "order_search_error": "Neočekivana pogreška",
          "goodsName": 'Naziv proizvoda'
        },
        "fail": {
          "payment_fail": "Plaćanje nije uspjelo",
          "back_home": "Povratak kući"
        }
      },
      "CountryGroup": {
        "title": "Zemlja/regija",
        "placeholder": "Pretraživanje zemlje ili regije",
        "clear": "Jasan",
        "history": "Povijest pretraživanja"
      },
      "PromotionCode": {
        "verification": {
          "title": "Vaučerski kôd",
          "minititle": "Vaučerski kôd",
          "input": "Unesite dodatni kod",
          "explain": "Savjeti: Dodirnite gumb za skeniranje u gornjem desnom kutu da biste skenirali QR kôd kartice vaučera ili ručno unesite kôd vaučera (osjetljiv na slučaj) ako ne radi.",
          "submit": "Podnijeti",
          "exchange": "Otkupiti",
          "cancel": "Otkazati",
          "Inquiry": "Jeste li sigurni da razmjenjujete",
          "ErrorCode": "Pogreška koda za ponovno punjenje"
        },
        "recharge_success": {
          "package": "Paket",
          "content": "Uspješno otkupljen",
          "back": "Povratak u trgovački centar",
          "view_packets": "Idi na moj paket"
        }
      },
      "order": {
        "state": {
          "inUse": "Aktiviran",
          "isFirst": "Prioritet",
          "toFirst": "Postavi Prioritet",
          "inactive": "Neaktiviran"
        },
        "periodUnits": {
          "minute": "minute (i)",
          "hour": "sat (s)",
          "day": "Dan (i)",
          "month": "Mjesec (i)"
        },
        "useIntro": {
          "tip1": "Neograničeni paket podataka ima veći prioritet od volumena podataka.",
          "tip2": "Prioritet upotrebe temeljit će se na datumu kupnje za istu vrstu paketa, tj. Paket s najranijim datumom kupnje prvo će se iskoristiti, dok je prioritet paketa s jednom regijom veći od regionalnog paketa.",
          "tip3": "Također možete ručno prilagoditi prioritet korištenja paketa iste vrste."
        },
        "myFlow": "Moji podaci",
        "remainingFlow": "Podaci su ostali",
        "remainingTime": "Veoma od ljevice",
        "remainingHighFlow": "Preostali su podaci velike brzine",
        "validPeriod": "Opravdanost",
        "noneFlow": "Nema paketa podataka",
        "noneFlowTip": "Kupite paket podataka i uživajte u visokokvalitetnoj mreži",
        "buyPackFlow": "Kupiti pakete",
        "checkInvalidFlow": "Provjerite paket podataka koji je istekao istekao",
        "orderList":  {
          "title": "moje naredbe",
          "amount_paid": "Ukupno",
          "device": "Uređaj u vlasništvu",
          "order_details": "Detalji narudžbe",
          "total_amont": "Međuzbroj",
          "orderSN": "Narudžba br.",
          "createTime": "Vrijeme stvaranja",
          "cancelTime": "Zatvoreno vrijeme",
          "payTime": "Vrijeme narudžbe",
          "unsubTime": "Otkazano vrijeme",
          "payMethod": "Način plaćanja",
          "thirdSN": "Transakcija br.",
          "delete": "Izbrisati",
          "cancel": "Otkaži narudžbu",
          "unsub": "Povrat novca",
          "goto_cancel": "Želite li otkazati narudžbu?",
          "goto_unsubscribe": "Želite li odjaviti narudžbu?",
          "delete_Tips": "Narudžba se ne može nastaviti nakon brisanja, stoga se ne mogu riješiti vaši problemi nakon usluge.Jeste li sigurni da ga želite izbrisati?",
          "status_success": "Završeno",
          "status_pending": "Neplaćeno",
          "status_cancel": "Zatvoreno",
          "status_unsub": "Otkazano",
          "payMethod_stripe": "Kreditna kartica"
        },
      },
      "registerlogin": {
        "create_account_tip":"Stvorite račun, započnite ekskluzivno iskustvo",
        "select_country_tip":"Uređaj za upotrebu uređaja/regija",
        "email_name": "Pošta",
        "phone_name": "Telefon",
        "email_address": "E-mail adresa",
        "password": "lozinka",
        "country": "zemlja",
        "select_country": "Odaberite zemlju",
        "cancel": "Otkazati",
        "confirm": "Naravno",
        "please_enter": "Unesite 6-20 znakova (kombinacija slova, brojeva ili simbola)",
        "select_country_tips": "Odabir zemlje namijenjen je gledanju lokalnih paketa. Ne može se promijeniti nakon registracije. Molimo potvrdite!",
        "global_roaming": "Međunarodni kod",
        "phone_number": "telefonski broj",
        "agree": "složiti se",
        "user_agreement": "Korisnički ugovor",
        "and": "i",
        "privacy_policy": "Pravila o privatnosti",
        "register_login": "Prijavite se ili prijavite se",
        "login_error": "Broj prijava je prečesti, pokušajte ponovo kasnije!",
        "register_error": "Broj registracija je prečesti, pokušajte ponovo kasnije!",
        "forgot_pwd": "Zaboravite lozinku",
        "app_tips": "Prijavite se u aplikaciju s ovim računom nakon što ga preuzmete kako biste pristupili više značajki.",
        "download_app": "Idite na preuzimanje aplikacije",
        "rememberPwd": "Sjetite se lozinke",
        "third_login": "Nastaviti sa",
        "agreement_tips": "Molimo provjerite korisnički ugovor i okvir Pravila o privatnosti",
        "selectCountry_tips": "Molim vas, imajte na umu da će registrirana zemlja izravno utjecati na sljedeće načine plaćanja i valute, odaberite prema vašim potrebama.",
        "login_error_cancel": "Korisnik je otkazao prijavu",
        "login_error_auth": "Dozvolite pop-up prozore u postavkama preglednika",
        "device_tips": "Uređaj čeka aktivaciju. Obrada unutar 24 sata."
      },
      "forgotPwd": {
        "forgot_pwd": "Zaboravite lozinku",
        "email_address": "E-mail adresa",
        "next": "Sljedeći",
        "email_has_been_sent": "Poslali smo e-poštu na %@email. Kliknite na vezu i slijedite korake za preuzimanje lozinke.",
        "have_retrieved_it": "Pronašao sam",
        "unable_to_receive_email": "Ne možete primiti e-poštu? Molimo provjerite postoje li e-mailovi s %@email ispod vaše neželjene pošte i izbrisani direktorij pošte",
        "or": "ili",
        "resend": "Odreći se",
        "global_roaming": "Međunarodni kod",
        "phone_number": "telefonski broj",
        "verification_code_has_been_sent": "Poslali smo potvrdni kôd na:",
        "verification_code": "Kod za provjeru",
        "no_verification_code_received": "Niste primili verifikacijski kod?",
        "please_enter": "Unesite 6-20 znakova (kombinacija slova, brojeva ili simbola)",
        "reset_password": "Poništite lozinku",
        "reset_successful": "Resetirajte uspješno"
      },
      "coupons": {
        "coupons_name": "Kuponi",
        "no_coupons": "Još nema kupona",
        "no_data": "Još nema podataka",
        "applicable_to_the_following": "Kuponi su prikladni za sljedeći paket podataka"
      },
      "digital":{
        "title":"Uređaj SN",
        "purchased":"Moje kupnje",
        "viewAll":"Više",
        "skinStore":"Prodavaonica proizvoda",
        "completed":"Kupljeno",
        "goBuy":"Kupiti",
        "order": {
          "title":"Kupljene narudžbe"
        },
        "detail": {
          "describe":"Opis"
        }
      },
      "viewPL": {
        "other": 'drugi'
      },
      "invalidFlow": {
        "stateName": "Status",
        "state": {
          "NOT_ACTIVATED": "Neaktiviran",
          "IN_USING": "Dostupan",
          "USE_END": "Iscrpljen",
          "EXPIRE": "Istekao",
          "TRANSFER": "Prijenos",
          "UNSUBSCRIBE": "Otkazati",
          "VALID": "Valjan",
          "INVALID": "Nevažeći",
          "EXCHANGE_POINTS": "Otkupite točke"
        },
        "noneFlow": "Nema isteklog paketa podataka",
        "pageName": "Istekli paket podataka"
      },
      "flowDetail": {
        "title": "Pojedinosti o podacima",
        "flow": "Podaci",
        "validTime": "Valjani pokreti",
        "invalidTime": "Vrijedi do",
        "coverage": "Pokrivenost",
        "useIntro": "Uvjeti i odredbe",
        "purchaseTime": "Kupljeno na",
        "subtotal": "Subtotalan",
        "status": "Status",
        "cancel": "Otkazati",
        "buyAgain": "Kupi ga opet",
        "validity": "Opravdanost",
        "tip": "Obavijest",
        "cancelTip": "Jeste li sigurni da želite vratiti ovaj paket?",
        "dataLeft": "Podaci su ostali"
      },
      "netError": {
        "try_again": "Pokušajte ponovo",
        "net_error": "Nema mreže",
        "try_again_desc": "Molimo provjerite postavku mreže i pokušajte ponovo"
      },
      "loadFail": {
        "try_again": "Pokušajte ponovo",
        "load_fail": "Učitavanje nije uspjelo",
        "load_fail_desc": "Učitavanje podataka nije uspjelo, pokušajte ponovo",
        "IMEI_Not_Exist": "Imei ne postoji, pokušajte ući s pravog ulaza",
        "Project_Not_Exist": "Dolazi do pogreške. Molimo kontaktirajte korisničku službu. (01)",
        "commonError": "Dolazi do pogreške. Molimo kontaktirajte korisničku službu."
      },
      "settlement_Easy_and_convenient": "Jednostavan i prikladan",
      "settlement_Great_deal": "Velik dio",
      "settlement_Safe_and_secure": "Sigurno i sigurno",
      "settlement_Autopay_service_regulation": "Regulacija automatskog plaćanja",
      "settlement_Read": "Čitati",
      "settlement_No_coupon": "Nema dostupnog kupona",
      "settlement_Subtotal": "Subtotalan",
      "settlement_Coupon": "Kupon",
      "settlement_TOTAL": "Ukupno",
      "settlement_promotion_tip": "Promotivna ponuda ne može se koristiti zajedno s bilo kojim kuponima",
      "settlement_coupon_tip": "Kupon se ne može koristiti zajedno s bilo kojom drugom promotivnom ponudom",
      "member_myFlow_noList": "Nema podataka~",
      "detail_se_content": "Siguran, jednostavan i prikladan način. Možete se odjaviti u bilo kojem trenutku.",
      "Enter_Promo_code": "Promocijski kod",
      "Enter_Promo_Coupon": "Kuponi",
      "settlement_Not_used_coupon": "Kupon se ne koristi",
      "settlement_Available_coupon": "Dostupan",
      "settlement_Unavailable_coupon": "Nedostupan",
      "please_Enter_Promo_code": "Unesite promotivni kod",
      "please_Select_Coupon_use": "Odaberite kupon koji želite koristiti.",
      "Buy_Now": "Kupiti sada",
      "Dont_Use_Any": "Nemojte koristiti nijedan",
      "settlement_confirm": "Potvrditi",
      "settlement_tips": "Potvrditi",
      "flowDetail_unsubscribe": "Odjaviti",
      "flowDetail_unsubscribed": "Odjavljen",
      "flowDetail_isCancelPackage": "Odjavite se pretplatite na ovaj paket?",
      "flowDetail_confirmAgreementUnsubscribe": "Ne možete imati puno nakon odjave. Jeste li sigurni da se želite odjaviti?",
      "flowDetail_cancel": "Otkazati",
      "flowDetail_cancelSuccess": "Uspješno odjaviti pretplatu",
      "packages_detail_promotion": "Promocija",
      "orderTips":{
        "iDay" : "dan",
        "iDays" : "dani",
        "iMonth" : "mjesec",
        "iMonths" : "mjeseci",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol Na prvoj kupnji, Platite %@money/%@periodSymbol kasnije, Možete se odjaviti u bilo kojem trenutku",
        'Monthly_discount':"Uštedite %@saveMoney svaki %@period! Možete se odjaviti u bilo kojem trenutku",
        'Ordinary_monthly_package':"Siguran, jednostavan i prikladan način. Možete se odjaviti u bilo kojem trenutku",
        "AlreadyPurchased":'Žao mi je što se trenutno možete pretplatiti samo na jedan paket podataka. Molimo odjavite se s “%@” i kasnije se pretplatite na bilo koji paket koji želite nakon što istekne.',
        "Contract_recommendation_First":'<label>Uz uslugu automatskog plaćanja, samo na vašoj prvoj kupnji, plaćajte samo</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">Možete se odjaviti u bilo kojem trenutku'
        +'<a class="btn">Pretplatiti se ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>Uz uslugu automatskog plaćanja, plaćajte samo</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Možete se odjaviti u bilo kojem trenutku'
        +'<a class="btn">Pretplatiti se ></a></p>',
        "Contract_recommendation_General":"<label>Uz automatsku uslugu</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Siguran, jednostavan i prikladan način. Možete se odjaviti u bilo kojem trenutku'
        +'<a href="javascript:;" class="btn">Pretplatiti se ></a></p>',
        'BanlanceDoubleCheck':'Jeste li sigurni da želite platiti saldo?',
    },
    feedback: {
      title: "povratne informacije",
      placeholder: "Unesite zemlju koju želite posjetiti ili bilo koja druga pitanja, a mi ćemo ispuniti vaše potrebe što je prije moguće!",
      submit: "Podnijeti",
      submit_success: "Uspješno podnijeti",
      other_opinions: "Druge mišljenja"
    },
    view_country_input: 'Unesite svoj račun',
    "select_package": {
      "title": "Odaberite Podatke",
      "allPackage": "Svi Podaci",
      "type": "Tip",
      "flow": "Podaci",
      "month_package": "Mjesečni plan",
      "flow_package": "Paket podataka",
      "time": "Trajanje",
      "period": "Ciklus",
      "auto_debit": "Info Autodebet",
      "auto_subscribe": "Auto-Obnavljanje",
      "detail": "Detalji Podataka",
      "carrier": "Podržani Operateri",
      "country": "Pokrivene Države",
      "notice": "Vodič za kupnju"
    }
}